var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE7174;}\n\t.st1{fill:#FAF2DA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M128.3,59.3c0,3.4,0,6.8,0,10.3c-0.1,0.3-0.2,0.7-0.3,1c-0.7,6.2-2.2,12.3-4.5,18.1 c-0.4,0.9-0.5,2-0.4,3c1.4,10,2.8,19.9,4.2,29.9c0.3,1.8,0.6,3.6,1,5.5c-0.3,0.4,0.7,1.2-0.5,1.3c-0.1-0.1-0.3-0.2-0.4-0.2 c-10.5-2.4-21-4.9-31.5-7.2c-0.6-0.1-1.5,0-2.1,0.3c-6.4,3.3-13.1,5.5-20.2,6.5c-1.6,0.2-3.2,0.5-4.8,0.7c-3,0-6,0-9,0 c-0.3-0.1-0.6-0.2-0.9-0.3c-2.2-0.4-4.5-0.6-6.6-1.1c-13.3-3.1-24.6-9.9-34-19.8c-8.8-9.3-14.7-20.2-17-32.9 c-0.3-1.8-0.6-3.7-0.9-5.5c0-3.2,0-6.3,0-9.5c0.1-0.3,0.2-0.5,0.3-0.8c0.5-3,0.9-6.1,1.6-9.1c3.3-13,10.3-23.8,20.2-32.6 C31.5,8.7,42.1,3.3,54.1,1.2c1.8-0.3,3.6-0.6,5.4-0.9c3.3,0,6.5,0,9.8,0c0.2,0.1,0.4,0.2,0.7,0.2c2.7,0.4,5.4,0.7,8.1,1.3 C103,7,123.2,28.1,127.3,53.2C127.6,55.2,127.9,57.2,128.3,59.3z M80.3,90.3c4.1-4,8.1-7.8,12.2-11.8c-5.4-5-10.7-9.9-16-14.8 c5.2-5.5,10.2-11,15.3-16.4c-4-3.4-7.9-6.7-11.7-10c-5.3,5.1-10.5,10.1-15.8,15.2c-5.5-5.1-11-10.1-16.5-15.2 c-3.9,3.7-7.6,7.3-11.5,11c5.5,5.3,10.8,10.4,16.2,15.5c-5.1,4.9-10,9.6-14.4,14c4.3,4.5,8.5,8.9,12.8,13.4 C55.6,86,60.3,81,65.1,75.8C70.2,80.7,75.2,85.4,80.3,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M80.3,90.3c-5.1-4.8-10-9.6-15.1-14.4C60.3,81,55.6,86,50.8,91.2c-4.3-4.5-8.5-8.9-12.8-13.4 c4.5-4.3,9.4-9.1,14.4-14c-5.4-5.2-10.7-10.3-16.2-15.5c3.8-3.7,7.6-7.3,11.5-11c5.5,5.1,11,10.1,16.5,15.2 c5.3-5.1,10.4-10.1,15.8-15.2c3.9,3.3,7.7,6.6,11.7,10c-5.1,5.5-10.1,10.9-15.3,16.4c5.3,4.9,10.6,9.8,16,14.8 C88.4,82.4,84.4,86.3,80.3,90.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBubble);
export default __webpack_public_path__ + "static/media/error-bubble.c8a7ad44ea66a2ae099ac9d19ba140a0.svg";
export { ForwardRef as ReactComponent };